import { AccordionSchemeDefinition } from "./accordion-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createAccordionMapDefinition } from "../../../utils/scheme-helper";

export const ACCORDION_SIZE_LARGE = "large";
export const ACCORDION_SIZE_SMALL = "small";
export const ACCORDION_SIZE_REGULAR = "regular";
export const ACCORDION_SIZES = [ACCORDION_SIZE_LARGE, ACCORDION_SIZE_REGULAR, ACCORDION_SIZE_SMALL] as const;

export const ACCORDION_MODE_SINGLE = "single";
export const ACCORDION_MODE_MULTIPLE = "multiple";
export const ACCORDION_MODES = [ACCORDION_MODE_SINGLE, ACCORDION_MODE_MULTIPLE] as const;

function createSchemes() {
  let newSchemes: AllColors.AccordionSchemeConfiguration<AccordionSchemeDefinition> = {};
  AllColors.ACCORDION_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      backgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      textColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      hoverTextColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      activeAccordionBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      activeAccordionBarColor: AllColors.COLOR_BRIGHT,
      accordionHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      borderHoverColor: AllColors.COLOR_BRIGHT_OPACITY_40
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const ACCORDION_SCHEME_CONFIG: AllColors.AccordionSchemeConfiguration<AccordionSchemeDefinition> = createSchemes();

export const ACCORDION_SCHEME_MAP: Map<BackgroundColor | "default", AccordionSchemeDefinition> = new Map(
  Object.entries(createAccordionMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    ACCORDION_SCHEME_CONFIG[config as string]
  ])
);
